import { PCA } from "ml-pca";
import { mlDataType } from "./Dataset";

export class PCAEncoder {
  dimensions;
  maxDim = 2;
  explained = [];
  model: PCA;

  constructor(maxDim = undefined) {
    if (maxDim !== undefined) {
      this.maxDim = maxDim;
    }
    this.initModel();
  }

  getProjectionLater() {}

  initModel() {}
  train(X: number[][]) {
    this.model = new PCA(X);
    const explained = this.model.getExplainedVariance();
    let cutoff = explained.filter((val) => val > 0.001).length;

    this.dimensions = Math.min(Math.min(cutoff, X[0].length), this.maxDim);
    this.explained = explained.slice(0, this.dimensions);
  }

  encodeTrainSet(mlData: mlDataType) {
    mlData.X = this.applyProjection(mlData.X);
    mlData.info.inputShape = this.dimensions;
    return mlData;
  }

  applyProjection(X: number[][]) {
    let xData: number[][] = [];
    const output = this.model.predict(X)["data"] as Array<Float32Array>;
    for (let i = 0; i < output.length; i++) {
      let val = Array.from(output[i]);
      xData.push(val);
    }
    xData = this.reduceDimensions(xData);
    return xData;
  }

  reduceDimensions(X: number[][]) {
    let reducedDim: number[][] = [];
    for (let row of X) {
      reducedDim.push(row.slice(0, this.dimensions));
    }
    return reducedDim;
  }
  scaleByVariance(X: number[][]) {
    let scaled: number[][] = [];
    for (let row of X) {
      row = row.map((val, i) => val * this.explained[i]);
      scaled.push(row.slice(0, this.dimensions));
    }
  }
}
